import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { Clock, CheckCircle2 } from "lucide-react";
import { useTranslation } from "react-i18next";

interface BookingSettingsProps {
  instantBooking: boolean;
  setInstantBooking: (value: boolean) => void;
  requiresScheduling: boolean;
  setRequiresScheduling: (value: boolean) => void;
}

export const BookingSettings = ({
  instantBooking,
  setInstantBooking,
  requiresScheduling,
  setRequiresScheduling,
}: BookingSettingsProps) => {
  const { t } = useTranslation();
  
  return (
    <div className="space-y-4">
      <div className="bg-white p-4 rounded-lg border border-gray-100 space-y-4">
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0 pt-0.5">
            <CheckCircle2 className="h-5 w-5 text-gebeya-pink" />
          </div>
          <div className="flex-1">
            <div className="flex items-center justify-between">
              <Label htmlFor="auto-approve" className="text-base font-medium">
                {t('services.autoApproveServiceRequests')}
              </Label>
              <Switch
                id="auto-approve"
                checked={instantBooking}
                onCheckedChange={setInstantBooking}
                className="data-[state=checked]:bg-gebeya-pink"
              />
            </div>
            <p className="text-sm text-gray-600 mt-1">
              {t('services.autoApproveDescription')}
            </p>
          </div>
        </div>
      </div>

      <div className="bg-white p-4 rounded-lg border border-gray-100 space-y-4">
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0 pt-0.5">
            <Clock className="h-5 w-5 text-gebeya-pink" />
          </div>
          <div className="flex-1">
            <div className="flex items-center justify-between">
              <Label htmlFor="requires-scheduling" className="text-base font-medium">
                {t('services.schedulingRequired')}
              </Label>
              <Switch
                id="requires-scheduling"
                checked={requiresScheduling}
                onCheckedChange={setRequiresScheduling}
                className="data-[state=checked]:bg-gebeya-pink"
              />
            </div>
            <p className="text-sm text-gray-600 mt-1">
              {t('services.schedulingRequiredDescription')}
            </p>
            {!requiresScheduling && (
              <div className="mt-2 text-sm text-amber-700 bg-amber-50 p-2 rounded-md">
                <p>
                  <strong>Note:</strong> {t('services.schedulingDisabledNote')}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}; 